import React from "react";

import { faMapMarker } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import type { EventExtraData } from "~/calendar/ViewEvent/index";
import { urlToAnchorTag } from "~/nav/panels/Meetings/MeetingInfoModal";

import styles from "./ViewEvent.module.css";

export default function LocationRow({ location }: { location: EventExtraData["location"] }) {
	if (!location) {
		return null;
	}

	return (
		<div className={styles.infoRow}>
			<div className={cx(styles.infoRow__icon, styles.centered)}>
				<FontAwesomeIcon fixedWidth icon={faMapMarker} />
			</div>
			<div className={cx(styles.infoRow__text, styles.textSmall)}>{urlToAnchorTag(location)}</div>
		</div>
	);
}
